import { gql, graphQueryBang } from "shared/lib/graphql"
import { topServicesMapper } from "./gql_data_mapper"
import { worksWithFragment } from "./top_services_fetcher"

const topServicesByCategoryQuery = gql`
  query(
    $service: String!
    $category_name: String
    $current_metric_date: DataServiceDate!
    $comparison_metric_date: DataServiceDate!
    $top_services_limit: Int
  ) {
    current: service_metrics(
      channel_module_name: $service
      category_name: $category_name
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
    ) {
      metrics {
        metric_date
        first_time_service_connections_in_TIME_PERIOD
        first_time_service_connections_all_time
      }
      category_metrics {
        metrics {
          top_services_TIME_PERIOD(limit: $top_services_limit) {
            user_count
            channel {
              module_name
            }
          }
        }
      }
    }
    comparison: service_metrics(
      channel_module_name: $service
      category_name: $category_name
      metric_start_date: $comparison_metric_date
      metric_end_date: $comparison_metric_date
    ) {
      metrics {
        metric_date
        first_time_service_connections_in_TIME_PERIOD
        first_time_service_connections_all_time
      }
    }
  }
`

const singleWorksWithQuery = gql`
  query(
    $service: String!
    $works_with_channel_name: String
    $daily_metric_start_date: DataServiceDate!
    $current_metric_date: DataServiceDate!
  ) {
    daily: service_metrics(
      channel_module_name: $service
      metric_start_date: $daily_metric_start_date
      metric_end_date: $current_metric_date
      works_with_channel_module_name: $works_with_channel_name
    ) {
      works_with_metrics {
        ${worksWithFragment}
      }
      errors {
        attribute
        message
      }
    }
  }
`

const composedCategoryQuery = timePeriodMetric =>
  topServicesByCategoryQuery.replace(/TIME_PERIOD/g, timePeriodMetric)

const composedWorksWithQuery = timePeriodMetric =>
  singleWorksWithQuery.replace(/TIME_PERIOD/g, timePeriodMetric)

export default function categoryDetailTopServicesFetcher(
  serviceModuleName,
  categoryName,
  worksWithChannelName,
  {
    dailyMetricStartDate,
    currentMetricDate,
    comparisonMetricDate,
    timePeriodInDays,
    timePeriodMetric,
    topServicesLimit,
  }
) {
  const categoryP = graphQueryBang(composedCategoryQuery(timePeriodMetric), {
    service: serviceModuleName,
    category_name: categoryName,
    comparison_metric_date: comparisonMetricDate,
    current_metric_date: currentMetricDate,
    top_services_limit: topServicesLimit,
  })

  const topServicesP = categoryP
    .then(data =>
      data.current.category_metrics[0].metrics[0][
        `top_services_${timePeriodMetric}`
      ].map(s => s.channel.module_name)
    )
    .then(topServices =>
      Promise.all(
        topServices.map(topService =>
          graphQueryBang(composedWorksWithQuery(timePeriodMetric), {
            service: serviceModuleName,
            works_with_channel_name: topService,
            daily_metric_start_date: dailyMetricStartDate,
            current_metric_date: currentMetricDate,
          })
        )
      )
    )

  return Promise.all([categoryP, topServicesP]).then(values => {
    const [serviceMetrics, worksWithMetrics] = values

    return topServicesMapper(
      {
        works_with_metrics: worksWithMetrics.map(
          ww => ww.daily.works_with_metrics[0]
        ),
        current: serviceMetrics.current,
        comparison: serviceMetrics.comparison,
      },
      timePeriodInDays,
      currentMetricDate,
      comparisonMetricDate,
      timePeriodMetric
    )
  })
}
